import { get } from 'utils';

export default async function getCities(...stateIds) {
  try {
    const { data } = await get(
      { apiKey: 'settings.returnLocations.facilities.locationsMap.getCities' },
      { params: { state_ids: stateIds.join(',') } }
    );
    if (data instanceof Object && Object.keys(data).length === 0) {
      return { data: [] };
    } else {
      return { data };
    }
  } catch (err) {
    return { err };
  }
}
